import $ from 'jquery';

// accessible-autocomplete library:
// https://github.com/alphagov/accessible-autocomplete
// Importing via NPM node_modules

import accessibleAutocomplete from 'accessible-autocomplete';

let zipOptions = [];
function fetchZipOptions(query, callback) {
    zipOptions = [];

    $.ajax("/acct/signin/soldlots/findzipcodes",
    {
        type: 'GET',
        data: {
            zipCodePrefix: query
        },
        beforeSend: function (request) {
            // Add CSRF token to the header
            let csrfToken = $("[name='__RequestVerificationToken']").val();
            request.setRequestHeader("__RequestVerificationToken", csrfToken);
        },
        success: function (response) {
            zipOptions = response;
            callback(zipOptions);
        },
        error: function (error) {
            $(".form-error").addClass("is-visible");
            $(".form-error p").text("Unexpected error occured. Please try again.");
        }
    });
}

let zipCodeLots = null;
function fetchAddressOptions(query, callback)
{
    if (zipCodeLots) {
        let addresses = zipCodeLots.Addresses.map(a => a.Address);
        callback( addresses.filter(function(addr) {
            return (addr.toLowerCase().indexOf(query.toLowerCase()) !== -1);
        }));
    }
}

var postalCodeContainer = document.getElementById('postal-code-container');
var addressContainer = document.getElementById('address-container');


if (postalCodeContainer) {
    accessibleAutocomplete({
        element: document.querySelector('#postal-code-container'),
        id: 'postal-code', // To match it to the existing <label>.
        source: fetchZipOptions,
        placeholder: 'Postal Code',
        required: 'true',
        minLength: 3,
        showNoOptionsFound: false,
        displayMenu: 'overlay',
        onConfirm: function(){
            // After some delay (to allow library to set the input value, kick off the validation 
            // by emulating a blur event on the postal code form field)
            setTimeout(function(){
                $("#postal-code").trigger("blur");
            }, 500);
        }
    });
}

if (addressContainer) {
    accessibleAutocomplete({
        element: document.querySelector('#address-container'),
        id: 'address', // To match it to the existing <label>.
        source: fetchAddressOptions,
        placeholder: 'Enter Street Address',
        required: 'true',
        minLength: 3,
        showNoOptionsFound: false,
        displayMenu: 'overlay'
    });
}

var postalInput = document.getElementById("postal-code");
var addressInput = document.getElementById("address");

if (postalInput) {
    postalInput.addEventListener("keyup", function () {
        //Keep the lots array and address fields empty
        //and disabled while the zipcode is less than 5
        //characters
        if (postalInput.value.length < 5) {
            zipCodeLots = null;
            addressInput.value = '';
            addressInput.setAttribute('disabled', true);
        }
    });
    postalInput.addEventListener("focus", function () {
        //Clear out error messaging under the zip field when focus
        //is on the field.
        $('#zipCodeErrorMsg').removeClass('is-visible');
    });
    postalInput.addEventListener("focusout", function () {
        if (postalInput.value !== '') {
            // clear address options
            zipCodeLots = null;

            $.ajax("/acct/signin/soldlots/getaddresses",
            {
                type: 'GET',
                data: {
                    zipCode: postalInput.value
                },
                beforeSend: function (request) {
                    // Add CSRF token to the header
                    let csrfToken = $("[name='__RequestVerificationToken']").val();
                    request.setRequestHeader("__RequestVerificationToken", csrfToken);
                },
                success: function (response) {
                    zipCodeLots = response;
                },
                error: function (error) {
                    $(".form-error").addClass("is-visible");
                    $(".form-error p").text("Unexpected error occured. Please try again.");
                }
            });
        }
    });

    postalInput.setAttribute('pattern', "number");
    postalInput.setAttribute('name', 'postal-code');
    postalInput.setAttribute('maxlength', '5');
    postalInput.setAttribute('aria-errormessage', 'zipCodeErrorMsg');

    // custom abide validator
    Foundation.Abide.defaults.validators['postal_code_validator'] = postalCodeValidator;
    postalInput.setAttribute('data-validator', 'postal_code_validator');

    $(postalInput).on('valid.zf.abide', function (e) {
        addressInput.removeAttribute('disabled');
        $('[for="address"]').removeClass('disabled');
    });
}

if (addressInput) {
    addressInput.addEventListener("focus", function () {
        //Clear out error messaging under the address field when focus
        //is on the field.
        $('#addressErrorMsg').removeClass('is-visible');
    });

    addressInput.setAttribute('name', 'address');
    addressInput.setAttribute('aria-errormessage', 'addressErrorMsg');
    addressInput.setAttribute('disabled', true);

    // custom abide validator
    Foundation.Abide.defaults.validators['address_validator'] = addressValidator;
    addressInput.setAttribute('data-validator', 'address_validator');
}

function postalCodeValidator($el) {
    var postal = $($el).val();

    if (postal != '') {
        if (zipOptions.indexOf(postal) !== -1) {
            addressInput.setAttribute('disabled', false);
            return true;
        } else {
            $('[data-form-error-for="postal-code"]').html('We cannot find the postal code entered in our system. Select a postal code from the suggestions or contact warranty@sheahomes.com');
            return false;
        }
    } else {
        $('[data-form-error-for="postal-code"]').html('Postal code is required');
        return false;
    }
}

function addressValidator($el) {
    var inputAddress = $($el).val();

    if (inputAddress != '') {
        let lot = zipCodeLots.Addresses.filter(function(lot) {
            // case insensitive comparison for address
            return inputAddress.toLowerCase() == lot.Address.toLowerCase();
        });

        if (lot.length > 0) {
            $('#lotCostCenterId').val(lot[0].LotCostCenterID);
            return true;
        } else {
            $('[data-form-error-for="address"]').html('We cannot find the street address entered in our system. Select a street address from the suggestions or contact warranty@sheahomes.com');
            return false;
        }
    } else {
        $('[data-form-error-for="address"]').html('Street address is required');
        return false;
    }
}
